import { cn } from '@newfront-insurance/core-ui/v2';
import type { ComponentProps, PropsWithChildren, JSX } from 'react';

export function ToolbarButton({ children, ...props }: PropsWithChildren & ComponentProps<'a'>): JSX.Element {
  return (
    <a
      className={cn(
        'text-steel-400 hover:bg-steel-100 focus:bg-steel-100 data-[active=true]:bg-steel-100 dark:text-foreground dark:hover:bg-brand-400 dark:focus:bg-brand-400',
        'flex h-10 w-10 items-center justify-center rounded-full indent-[-9999px] transition-all duration-200 ease-in-out hover:cursor-pointer focus:outline-hidden',
      )}
      {...props}
    >
      {children}
    </a>
  );
}
